<template>
  <SafeTeleport to="#widgets-bar" :force="true">
    <div
      :class="{
        'rounded-xl bg-white flex flex-col min-h-40': base,
      }">
      <slot></slot>
    </div>
  </SafeTeleport>
</template>

<script setup lang="ts">
import SafeTeleport from '@/apps/slideshow/teleport/SafeTeleport.vue';

defineProps({
  base: { type: Boolean },
});
</script>

<style scoped></style>
